import * as yup from "yup";

export const subscriptionSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  description: yup.string().required("Description is required"),
  price: yup
    .number()
    .typeError("Price must be a number")
    .min(0, "Price cannot be negative")
    .required("Price is required"),
  billing_cycle: yup
    .string()
    .oneOf(["N/A", "Monthly", "Yearly", "Weekly"], "Please select a billing cycle")
    .required("Billing cycle is required"),
  duration : yup.number(),
  features: yup.array().of(
    yup.object().shape({
      _id: yup.string().optional(),
      title: yup.string().required("Feature title is required"),
      status: yup
        .string()
        .oneOf(
          ["active", "inactive"],
          "Status must be either active or inactive"
        )
        .required("Status is required"),
    })
  ),
  consent: yup.boolean().when("price", (price, schema, { context }) => {
    const defaultPrice = context?.defaultPrice ?? "";
    const hasChanged = price !== defaultPrice;
    return hasChanged
      ? schema.oneOf([true], "Consent is required when price is changed")
      : schema.notRequired();
  }),
});
